import { inject } from '@angular/core';
import { RedirectFunction, Router } from '@angular/router';

import { VippsLoginService } from './services/vipps-login.service';

/**
 * Vipps returns only to a redirect URI registered exactly, and store slugs vary,
 * so every return lands here and is sent on to the checkout it left from.
 *
 * The code stays behind in the saved checkout: only the opaque `state` goes on
 * in the URL, so the pages after this one never carry the code. This page load
 * itself does: Plausible drops the query in src/index.html, but Sentry can still
 * report it. The code is useless without the PKCE verifier and the client secret.
 *
 * Without a live checkout (expired, or the phone reopened the shop in another
 * browser) there is nothing to go back to; the last store says so.
 */
export const vippsCallbackRedirect: RedirectFunction = ({ queryParams }) => {
  const router = inject(Router);
  const vippsLogin = inject(VippsLoginService);
  const state: string | undefined = queryParams['state'];
  const outcome = { code: queryParams['code'] ?? null, error: queryParams['code'] ? null : queryParams['error'] ?? 'unknown' };
  const draft = state && vippsLogin.recordOutcome(state, outcome) ? vippsLogin.peekDraft(state) : null;
  if (!state || !draft) {
    return router.createUrlTree(['/'], { queryParams: { vipps: 'mangler' } });
  }
  return router.createUrlTree([draft.returnPath], {
    queryParams: { ...draft.queryParams, vipps: state },
  });
};
